import React from 'react';
import { Form, Input, Space, Button, Tooltip, Tag } from 'antd';
// --- MODIFIED: Added DeleteOutlined ---
import { CheckCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const EditableSection = ({
                             contentKey,
                             children,
                             editContent,
                             isEditing,
                             isAdapted,
                             onEdit,
                             onChange,
                             onSave,
                             onCancel,
                             onDelete, // New prop
                             deleteTooltip = "Delete this item", // New prop with default
                             component = 'div',
                         }) => {
    const Wrapper = component;

    const baseStyle = {
        padding: '10px',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        gap: '10px',
        position: 'relative', // Ensures the tag positions correctly
    };

    const wrapperStyle = isAdapted
        ? {
            ...baseStyle,
            background: '#e6f4ff',
            border: '1px solid #91caff',
            borderRadius: '6px',
        }
        : baseStyle;

    return (
        <Wrapper style={wrapperStyle}>
            {isEditing ? (
                <Form.Item style={{ marginBottom: 0, flexGrow: 1 }}>
                    <TextArea
                        value={editContent}
                        onChange={(e) => onChange(e.target.value)}
                        autoSize={{ minRows: 2, maxRows: 10 }}
                    />
                    <Space style={{ marginTop: 8 }}>
                        <Button type="primary" size="small" onClick={onSave} icon={<CheckCircleOutlined />}>Save</Button>
                        <Button size="small" onClick={onCancel}>Cancel</Button>
                    </Space>
                </Form.Item>
            ) : (
                <>
                    <div style={{ flexGrow: 1 }}>{children}</div>
                    {/* --- MODIFIED: Added Space to group buttons --- */}
                    <Space>
                        <Tooltip title="Adapt this section">
                            <Button
                                type="text"
                                shape="circle"
                                icon={<EditOutlined style={{ fontSize: '20px' }} />}
                                onClick={() => onEdit(contentKey, editContent)}
                                style={{ color: '#888' }}
                            />
                        </Tooltip>
                        {/* --- START: New Delete Button --- */}
                        {onDelete && (
                            <Tooltip title={deleteTooltip}>
                                <Button
                                    type="text"
                                    danger
                                    shape="circle"
                                    icon={<DeleteOutlined style={{ fontSize: '20px' }} />}
                                    onClick={onDelete}
                                />
                            </Tooltip>
                        )}
                        {/* --- END: New Delete Button --- */}
                    </Space>
                    {isAdapted && (
                        <Tag icon={<CheckCircleOutlined />} color="success"
                             style={{ position: 'absolute', bottom: 5, right: 5, zIndex: 1 }}>
                            Adapted
                        </Tag>
                    )}
                </>
            )}
        </Wrapper>
    );
};

export default EditableSection;